import React, { useEffect, useState } from "react";
import { Layout, Table, Avatar } from "antd";
import { useHistory, useRouteMatch } from "react-router-dom";
import "./Customers.scss";
import moment from 'moment';

const CustomerFavorite = ({customerFav=[]}) => {
    const [customers, setCustomers] = useState([]);
  const match = useRouteMatch();
  const [state, setState] = useState({});
  const history = useHistory();

  const columns = [
    {
      title: "Item Name",
      dataIndex: "name",
      key: "name",
    //   width: 200,
      render: (e, record) => (
        <div className="image-name">
         
            <Avatar size="large" shape="square" src={record?.menu_item?.photo_url} />
    
            <div className="cust-name">
              {record?.menu_item?.name}
            </div>
           
       
        </div>
      ),
    },
    {
      title: "Price",
      dataIndex: "email",
      key: "email",
      render: (e, record) => (
        <div className="view-profile">
          {record?.menu_item?.price}
        </div>
      ),
    },
    {
      title: "Added to Favorites Date",
      dataIndex: "order_date",
      key: "order_date",
      render:(e,record)=> (<div>{moment(record?.menu_item?.upatted_at).format("MM/DD/yyyy")}</div>)
    },
   
   
  ];

  useEffect(() => {
   const customers=[
    {
        name:"Burger",
        email:"11",
        order_date:"12/4/2023",
        id:"122"

    },
    {
        name:"Samosa",
        email:"67",
        order_date:"12/4/2023",
        id:"1272"

    },
    {
        name:"Samosa",
        email:"67",
        order_date:"12/4/2023",
        id:"1252"

    },
    {
        name:"Samosa",
        email:"67",
        order_date:"12/4/2023",
        id:"1226"

    },
    {
        name:"Samosa",
        email:"67",
        order_date:"12/4/2023",
        id:"1225"

    },
   ]
   setCustomers(customers)
  }, [])
  

 
  return (
    <Layout className="">
      
        <div className="site-layout-background">
          <Table columns={columns} dataSource={customerFav} 
          onRow={(record, rowIndex) => {
            return {
            };
          }}/>
          </div>
      
    </Layout>
  );
};

export default CustomerFavorite;
